import * as THREE from 'three'
// import GLTFLoader from 'three-gltf-loader'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader'

import anime from 'animejs'
import { REMOTE_MODEL } from 'constants/threeConstants';
import { FINGER_ANIMATION } from 'constants/commonContsnts';
import { debounce } from 'throttle-debounce';
import { ThrowButtonEvent } from 'actions/freestyle';
import { AnimationAction } from 'three/src/animation/AnimationAction';

export interface FreestyleButtonEvent {
  name: string,
  greenPresed?: boolean
}

const DEFAULT_RATIO = 16 / 9
const SCALE_RATIO = 64.29
// const DEFAULT_X_MOBILE = 40
const MIN_MOBILE_WIDTH = 825
const POSITIONS = {
  DEFAULT: {
    RESTING: [0,-100,-150],
    HIDDEN: [1,1,1],
  },
  MOBILE: {
    RESTING: [50,-77,-80],
    HIDDEN: [1,1,1],
  }
}

const lightColors = {
  on: 0xffff00,
  off: 0xffffff
}
// const MIN_MOBILE_WIDTH = 812.8

export default class Remote {
  protected loader = new GLTFLoader()
  model?: THREE.Scene
  protected clickable: any[] = []
  protected hoveredItem?: any
  protected lastClicked?: any
  protected mobile = false
  protected shown = false
  protected animation = false
  protected animationList: any
  protected fingerAnimation?: AnimationAction
  protected secondLight!: THREE.Object3D 
  protected primaryLight!: THREE.Object3D 
  protected greenButton?: any
  protected redButton: any
  mixer?: THREE.AnimationMixer 
  greenPressed?: Boolean
  blockSecondary = false
  onFirstGreenButtonClick(){}
  onFirstButtonClick(a: any){}
  greenButtonHold: any
  isFreestyle = false
  greenHoldDuration = 0
  greenButtonHoldUp: any
  greenHoldTimeout: any
  listeners: {
    up: any[],
    down: any[],
    move: any[]
  } = {
    up: [],
    down: [],
    move: []
  }
  mobileRatio = 60
  updatePositionEnabled = true
  lastClickDuration: number | boolean = 0
  lastClickTimeout: any = null
  allowGreenPress: boolean = true
  enabled = true
  freestyleClick!: (...args: Parameters<typeof ThrowButtonEvent>) => void
    
  
  
  async init(onButtonClick: (...args: Parameters<typeof ThrowButtonEvent>) => void) {
    this.freestyleClick = onButtonClick
    
    

    this.greenButtonHoldUp = debounce(300, (off: false) => {
      const dir = !this.greenPressed
      !off && this.setGreenButtonClicked(dir)
      
      this.onFirstGreenButtonClick()
      this.onFirstGreenButtonClick = () => {}
      
      this.fingerAnimation!.clampWhenFinished = true
      this.fingerAnimation!.paused = false
      this.fingerAnimation!.play()
      this.fingerAnimation!.timeScale = dir ? 2 : -2
    })

    this.onClickGreenButtonEvent = debounce(200, this.onClickGreenButtonEvent)
    
    window.addEventListener('mouseup', this.greenButtonUp)
    window.addEventListener('touchend', debounce(300, this.greenButtonUp))


    this.setGreenButtonClicked = debounce(300, this.setGreenButtonClicked)
    // this.greenButtonDown = debounce(300, this.greenButtonDown)

    return await this.initModel()
  }

  greenButtonUp = () => {
    if(this.lastClickTimeout) {
      if(this.lastClickTimeout + this.greenHoldDuration > Date.now()) {
        this.fingerAnimation!.paused = false
        this.fingerAnimation!.play()
        this.fingerAnimation!.timeScale = -2
        this.setGreenButtonClicked(false)
      } else {
        this.setGreenButtonClicked(true)
        
        this.onFirstGreenButtonClick()
        this.onFirstGreenButtonClick = () => {}        
      }
      if(this.greenHoldTimeout) clearInterval(this.greenHoldTimeout)
      this.lastClickTimeout = null
    }
    
  }

  greenButtonDown = () => {
    // this.lastClickTimeout = Date.now()
    console.log('greenbuttondown')
    

    this.fingerAnimation!.clampWhenFinished = true
    this.fingerAnimation!.paused = false
    this.fingerAnimation!.play()
    this.fingerAnimation!.timeScale = 2

    // this.greenHoldTimeout = setTimeout(() => {
      this.lastClickTimeout = null
      this.setGreenButtonClicked(true)
        
      this.onFirstGreenButtonClick()
      this.onFirstGreenButtonClick = () => {}

      this.greenHoldTimeout = null
    // }, this.greenHoldDuration)
  }

  onTurnOn = () => {
    this.fingerAnimation!.clampWhenFinished = true
    this.fingerAnimation!.paused = false
    this.fingerAnimation!.play()
    this.fingerAnimation!.timeScale = 2
    
    setTimeout(() => {
      this.fingerAnimation!.clampWhenFinished = true
      this.fingerAnimation!.paused = false
      this.fingerAnimation!.play()
      this.fingerAnimation!.timeScale = -2
    }, 200);
  }
 
  
  protected setGreenButtonClicked = (clicked: boolean) => {
    this.greenPressed = clicked
      
    
    //@ts-ignore
    this.secondLight.material.color.set(clicked ? lightColors.on : lightColors.off)
    //@ts-ignore
    this.primaryLight.material.color.set(clicked ? lightColors.off :  lightColors.on )

  }

  initModel(): Promise<THREE.Scene> {
    return new Promise(resolve => {
      this.loader.load(REMOTE_MODEL, (data) => {

        this.model = data.scene
        this.mixer = new THREE.AnimationMixer(this.model)
        this.animationList = data.animations
        this.fingerAnimation = this.mixer.clipAction(
          data.animations.find(item => item.name === FINGER_ANIMATION)!
        )

        this.fingerAnimation.loop = THREE.LoopOnce

        // this.fingerAnimation.loop = THREE.LoopOnce

        this.model.scale.set(0.5, 0.5, 0.5)
        this.onResize(true)
        // this.model.position.set(0, -200, -150)

        
        this.model!.traverse(item => {
          if(item.name.toLowerCase().includes('btn')) {
            item.userData.button = true
            
            const side = parseInt(item.name.replace( /[^\d.]/g,'')) % 2
            item.userData.side = side
          }
          if(item.name.toLowerCase().includes('em') ) {
            item.visible = false
          }

          if(item.name.includes('Remote_mesh')) {
            item.visible = true
          }
          
          if(item.name.includes('Remote_mesh001')) {
            item.visible = true
          }

          if(item.name.toLowerCase().includes('greenbtn')) {
            this.greenButton = item
            item.userData.clickable = true
          }

          if(item.name.includes('Remote_Second')) {
            this.secondLight = item
          }
          if(item.name.includes('Remote_Primary')) {
            this.primaryLight = item
          }

          if(item.name === 'RedBtn') {
            this.redButton = item
          }
          
          //@ts-ignore
          if(item.name === 'Remote_mesh001') {
            //@ts-ignore
            item.material.transparent = false
            //@ts-ignore
            item.material.needsUpdate = true
          }
          //@ts-ignore
          if(item.material) {
            //@ts-ignore
            const newMat = item.material.clone()
            item.userData.defaultColor = newMat.color
            //@ts-ignore
            item.material.transparent = false
            //@ts-ignore
            item.material = newMat
          }



        })        

        window.addEventListener('orientationchange', () => this.onResize())
        window.addEventListener('resize', () => this.onResize())
        resolve(this.model)
      })
    })
  }

  
  onResize = (avoidAnim?: Boolean) => {
      this.mobile = window.innerWidth <= MIN_MOBILE_WIDTH
      // this.mobile = true
      if(!this.animation && this.shown && this.updatePositionEnabled) {
        if(this.mobile) {
          this.model!.position.y = POSITIONS.MOBILE.RESTING[1]
          this.model!.position.z = POSITIONS.MOBILE.RESTING[2]
        } else {
          this.model!.position.y = POSITIONS.DEFAULT.RESTING[1]
          this.model!.position.z = POSITIONS.DEFAULT.RESTING[2]
        }
      } 
      if(avoidAnim) {
        this.model!.position.z = this.mobile ? POSITIONS.MOBILE.RESTING[2] : POSITIONS.DEFAULT.RESTING[2]
        this.model!.position.y = -200
      }
  }

  setListeners = (up: Function[], down: Function[]) => {
    this.listeners.up = up || [() => {}]
    this.listeners.down = down ||  [() => {}]
  }


  updatePosition(width: number, height: number) {
    if(this.model && this.updatePositionEnabled) { 
      const CURRENT_RATIO = width / height
      
      if(this.mobile) {
        this.model.position.x = DEFAULT_RATIO / CURRENT_RATIO * 40
        // console.log(DEFAULT_RATIO / CURRENT_RATIO)
        // this.model.position.x = 40
      } else{
        this.model.position.x = (DEFAULT_RATIO - CURRENT_RATIO) * SCALE_RATIO
      }
    }
  }

  toggle(show: Boolean) {
    show ? this.show() : this.hide()
  }

  isButton(item: THREE.Object3D) {
    return item.name.toLocaleLowerCase().includes('btn') && item !== this.greenButton && item !== this.redButton
  }
  
  highLightButtons(buttonsList: string[]) {
    this.model!.children
      .forEach((item) => {
        if(this.isButton(item)) {
          const isActive = buttonsList.includes(item.name)
          
          if(isActive) {
            //@ts-ignore
            item.material.color.set('#ffffff')
            //@ts-ignore
            item.material.emissive.setRGB(0.2, 0.2, 0.2)
          } else {
            //@ts-ignore
            item.material.emissive.setRGB(0, 0, 0)
            //@ts-ignore
            item.material.color.setRGB(.5, .5, .5)

          }
        }
      })

  }

  setActiveLights(list: string[], cb?: Function) {
    if(!cb) this.greenButtonReset()
    
    this.primaryLight.visible = true
    this.secondLight.visible = true
    
    this.model!.traverse(item => {
      if (item.name.toLowerCase().includes('btn') && item !== this.greenButton) {
        if(!list.includes(item.name) ) {
          item.userData.clickable = false
          //@ts-ignore
            if(item.material) {
              //@ts-ignore
              item.material.emissive.setRGB(0, 0, 0)
              //@ts-ignore
              item.material.color.setRGB(0.5, 0.5, 0.5)
            }
        } else {
          //@ts-ignore
          if(item.material) {
            //@ts-ignore
            item.material.emissive.setRGB(0.2, 0.2, 0.2)
            //@ts-ignore
            item.userData.highLightEmmisive = item.material.emissive.clone()
            //@ts-ignore 
            item.material.color.set('#ffffff')
            // item.material.visible = false
            //@ts-ignore
            item.material.needsUpdate = true

          }
          this.clickable.push(item)
          item.userData.clickable = true
          item.userData.onClick = cb
        }
      } 
    })
  }

  greenButtonReset() {
    this.fingerAnimation!.reset()
    this.fingerAnimation!.stop()
    this.setGreenButtonClicked(false)
    this.lastClickTimeout = null
  }

  initFreestyle() {
    this.allowGreenPress = true
    this.isFreestyle = true

    this.onFirstButtonClick = () => {}
    this.blockSecondary = false
    this.onFirstGreenButtonClick = () => {}
              
    this.primaryLight.visible = true
    this.secondLight.visible = true

    this.turnOff(true)
    this.toggle(true)
  }
  
  stopFreestyle() {
    this.isFreestyle = false
              
    this.primaryLight.visible = true
    this.secondLight.visible = true
    this.highLightButtons([])
    this.turnOn()
    this.toggle(false)
  }
  
  turnOn() {
    this.enabled = true
    
    //@ts-ignore
    this.primaryLight.material.color.set(lightColors.on)
    //@ts-ignore
    this.secondLight.material.color.set(lightColors.off)
  }
  
  turnOff(c?: boolean) {
    this.enabled = false

    this.greenPressed && !c && this.greenButtonHoldUp(true)
    
    this.highLightButtons([])
    this.setActiveLights([])
    
    setTimeout(() => {
      //@ts-ignore
      this.primaryLight.material.color.set(lightColors.off)
      //@ts-ignore
      this.secondLight.material.color.set(lightColors.off)
    }, 301);
  }
  
  onClickGreenButtonEvent() {
    this.greenPressed ? 
      this.greenButtonHoldUp()
      :
      this.greenButtonDown()
  }

  onClick = (item: THREE.Object3D) => {
    
    if(item === this.redButton) {
      this.turnOff()
    }
    
    if(item === this.greenButton && this.allowGreenPress) {
      if(this.isFreestyle && !this.enabled) {
        this.turnOn()

        // this.fingerAnimation!.play()
        this.onTurnOn()
        return 
      } 
      
      this.onClickGreenButtonEvent()
      
    } else if(item && !this.isFreestyle && item.userData.clickable && (!this.blockSecondary || item.userData.side) ) {
      this.listeners.down.forEach(f => f(item.userData.side))

      this.onFirstButtonClick(item.userData.side)

      if(item.userData.onClick) {
        item.userData.onClick()
      }
      this.lastClicked = item

    // } else if (item && item.userData.side && this.isFreestyle) {
    //   this.listeners.down.forEach(f => f({name: item.name, greenPressed: this.greenPressed}))
    } else if (this.isFreestyle) {
      
      this.onFreestyleClicked(item, 'down')
    }
  }

  onFreestyleClicked(item: THREE.Object3D, type: 'down' | 'up') {
    
    
    this.freestyleClick({
      name: item ? item.name : undefined,
      type,
      greenPressed: !!this.greenPressed
    })
  }

  onMove = (item: THREE.Object3D) => {
    this.hoveredItem = item

    if(item === this.greenButton) {
      // this.greenButtonClick()
    } else {
      this.clickable.forEach(cItem => {
        if(cItem.userData.clickable) {
          if(cItem !== this.hoveredItem ) {
            //@ts-ignore
            cItem.material.emissive.setRGB(0.2, 0.2, 0.2)
          }
        }
      })
      
      if(item && item.userData.clickable) {
        if(!item.userData.clicked) {
          
          //@ts-ignore
          item.material.emissive.setHex(0xa1a1a1)
        }
      }
    }
  }

  onUp = (item: THREE.Object3D) => {
    if(item === this.greenButton) {
      // this.greenButtonClick()
    }
    else if (item && item.userData.clickable) {
      //@ts-ignore
      this.listeners.up.forEach(f => f(item.userData.side))
    } else if (this.lastClicked) {
      this.listeners.up.forEach(f => f(this.lastClicked.userData.side))
      this.lastClicked = null
    } else if (this.isFreestyle) {
      this.onFreestyleClicked(item, 'up')
    }
  }

  protected show() {
    this.shown = true
    this.animation = false

    anime({
      targets: this.model!.position,
      y:  POSITIONS[this.mobile ? 'MOBILE' : 'DEFAULT'].RESTING[1],
      duration: 500,
      easing: 'easeInCubic',
      complete: () => {
        this.animation = false
      }
    })
  }


  
  protected hide() {
    this.shown = false
    this.animation = true

    anime({
      targets: this.model!.position,
      y: -200,
      duration: 500,
      easing: 'linear',
      complete: () => {
        this.animation = false
      }
    })
  }
}